<template>
  <div style="padding-bottom: 60px" v-if="body_show">
    <!-- 公用头部 -->
    <public-header :colors="'#fff'" :headimg="headImg"></public-header>
    <div class="men_detail">
      <img  src="@a/x-ceping71detail/1.png" />
      <img  src="@a/x-ceping71detail/3.png" />
      <img  src="@a/x-ceping71detail/4.png" />
      <img  src="@a/x-ceping71detail/5.png" />
      <img  src="@a/x-ceping71detail/6.png" />
      <img  src="@a/x-ceping71detail/7.png" />
      <img  src="@a/x-ceping71detail/8.png" />
      <img  src="@a/x-ceping71detail/9-1.png" />
    </div>
    <div class="men_foots">
      <router-link :to="{path:'/ceping71_report',query:$route.query}" v-if="data.report">查看报告</router-link>
      <router-link :to="{path:'/ceping71',query:$route.query}" v-else>立即开始测评</router-link>
    </div>
    <!-- 悬浮按钮 -->
    <div class="tjhy" @click="card_show=true">
      <div>推荐好友</div>
    </div>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <public-card :imgLink="imgLink" ref="card"></public-card>
  </div>
</template>
<script>
import {
  ceping71_detail,
  ceping_event,
} from "@/api/measurement";
import {
  queryString,
  getStorage
} from "@/utils/tools";
import {
  shareCon
} from "@/utils/wxconfig";
let img = require('../../../assets/cep_ewm.png');
export default {
  data() {
      return {
        headImg: "",
        picture: "",
        data: {},
        body_show: false,
        subscribe: false,
        card_show: false,
        imgLink: img,
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: ""
        }
      }
    },
    methods: {
      pullData() {
        let cid = this.$route.query.cid;
        ceping71_detail({
            cid: cid
          })
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
            this.headImg = data.headimgurl;
            this.subscribe = data.report;
            // 给wxconfig传对象
            this.type_obj.evaluation_id = this.$route.query.cid || 71;
            this.type_obj.evaluation_name = data.headtitle;
            this.type_obj.evaluation_user_id = String(data.uid);
            this.type_obj.path = this.$route.path;
            shareCon("ceping71", this, this.type_obj);

            ceping_event({ lead_sid: this.$route.query.lead_sid,
              cid: data.cid,
              event: 'ViewDetails',
            }).then(res=>{
              // 页面访问统计
            });

            // 神策统计--打开页面时触发
            // sensors.track('evaluationPage', {
            //   evaluation_id: this.$route.query.cid || 71,
            //   evaluation_name: this.data.headtitle,
            //   evaluation_url: window.location.href,
            //   evaluation_page_title: this.data.headtitle,
            //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
            //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
            // })
          })
      },
      complete_click() {
        if (!this.subscribe) {
          this.$router.push("/ceping71_report")
        } else {
          this.$refs.card.card_show = true;
        }
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('?');
        // let last = url_.lastIndexOf('.');
        let x = url_.substring(index);
        return x;
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96) + px;
  line-height: changeRem(1.96) + px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #EB5032;
  z-index: 2;
  color: #fff;
  font-size: changeRem(0.68) + px;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff
  }
}

.tjhy {
  position: fixed;
  z-index: 998;
  width: 150px;
  top: changeRem(2.72)+px;
  text-align: center;
  right: 50%;
  margin-right: -375px;
  height: changeRem(1.4)+px;
  background-color: #EB5032;
  border-radius: changeRem(.56)+px 0 0 changeRem(.56)+px;
  padding-left: changeRem(.12)+px;
  padding-top: changeRem(.1)+px;
  div {
    width: changeRem(2.84)+px;
    line-height: changeRem(1.12)+px;
    border: 2px solid #ffffff;
    border-right: 0;
    color: #FFFFFF;
    font-size: changeRem(.48)+px;
    border-radius: changeRem(.56)+px 0rem 0rem changeRem(.56)+px;
  }
}

.tjhy.kfan {
  top: changeRem(4.72)+px;
  background-color: #F57F17;
  div {
    width: changeRem(2.84)+px;
    line-height: changeRem(1.12)+px;
    border: 2px solid #ffffff;
    border-right: 0;
    color: #FFFFFF;
    font-size: changeRem(.48)+px;
    border-radius: changeRem(.56)+px 0rem 0rem changeRem(.56)+px;
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
</style>
